const contains = (array, elem) => array.indexOf(elem) > -1;

export default contains;
